
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className="text-base space-y-3">
      <h3 className="text-lg font-bold">About us</h3>
      <p>
    Loan.co.uk Limited is an FCA authorised credit broker. Our purpose is to match consumers with
    the right loan for their circumstances. Founded in 2005, Loan.co.uk Limited has a depth of
    industry experience within financial services broadly, as well as significant experience working
    for the lenders who provide the loans. Our company ethos is to be simple, fair and supportive of
    our customers and to focus on providing the best and most comprehensive service in the market.
      </p>
      <p>
    Loan.co.uk Limited – Company Number is 05455171. Our registered office and trading address is 46
    Alexandra Street, Southend On Sea, Essex, UK, SS1 1BJ.
      </p>
      <h3 className="text-lg font-bold">Who regulates us?</h3>
      <p>
    Loan.co.uk Limited is authorised and regulated by the Financial Conduct Authority. You can find
    our details on the FCA Financial Services Register at{' '}
    <a href="https://register.fca.org.uk" target="_blank" className="underline">
        https://register.fca.org.uk
    </a>
    . Our FCA Registration Number is 718486.
      </p>
      <p>
    We are also registered with the Information Commissions Office as a Data Controller. Our Data
    Protection Register number is Z2169336.
      </p>
      <h3 className="text-lg font-bold">How we collect your information</h3>
  <p>
    We may obtain information from you through our websites, mobile applications or other similar devices, channels or applications operated by or on behalf of any of the trading names listed here.
  </p>
      <h3 className="text-lg font-bold">Information we may collect from you</h3>
  <p>
    We will only collect the necessary information from you that we will need to provide you with our credit broker service.
  </p>
      <p>We may collect and process the following information about you:</p>
      <ul className="space-y-3" style={{
        paddingLeft: 25
      }}>
    <li>
        Directly from you, via our application form or any other online forms on this or any other
        of our websites, such as:
        <div className="space-y-1" style={{
            paddingLeft: 8
          }}>
            <div className="inline-block">&#x2022; Name and date of birth</div>
            <div className="inline-block">&#x2022; E-mail addresses and telephone numbers</div>
            <div className="inline-block">&#x2022; Home address and residential status</div>
            <div className="inline-block">&#x2022; Name and contact details of your employer</div>
            <div className="inline-block">&#x2022; Income details, including your pay dates</div>
            <div className="inline-block">&#x2022; Bank account details;</div>
        </div>
    </li>
    <li>
        <p>
            correspondence, or a record of it if you should contact us, together with your contact
            details and our responses;
        </p>
    </li>
    <li>
        <p>
            surveys that we use for research purposes, which we have asked you to complete (although
            you do not have to respond to them);
        </p>
    </li>
    <li>
        <p>
            details of your visits to our Sites (including, but not limited to, traffic data,
            location data, weblogs and other communication data, whether this is required for our
            own billing purposes or otherwise) and the resources that you access; and
        </p>
    </li>
    <li>
        <p>
            information from third parties in respect of you which may include your employer, a
            referee or a person residing or working from another country.
        </p>
    </li>
      </ul>
      <h3 className="text-lg font-bold">How we use your information</h3>
      <p>We use information held about you in the following ways:</p>
      <ul className="space-y-3" style={{
        paddingLeft: 25
      }}>
    <li>
        <p>
            To process and submit your Application Form to lenders and credit brokers to apply for
            the funds you have requested;
        </p>
    </li>
    <li>
        <p>To provide you with the best possible service;</p>
    </li>
    <li>
        <p>
            to ensure that content from our websites is presented in the most effective manner for
            you and for your computer;
        </p>
    </li>
    <li>
        <p>To notify you about changes to our products and services;</p>
    </li>
      </ul>
      <h3 className="text-lg font-bold">Sharing your information with third parties</h3>
      <p>In addition to the above, we may disclose your personal information to third parties:</p>
      <ul className="space-y-3" style={{
        paddingLeft: 25
      }}>
    <li>
        <p>
            to prepare or send any communications to you, or to assist us in connection with any of
            our administrative or business functions, or in the provision of any of our services to
            you;
        </p>
    </li>
    <li>
        <p>to our agents, staff and approved third parties to carry out services for us;</p>
    </li>
    <li>
        <p>
            if the Company or substantially any of its assets, are acquired by a third party, in
            which case personal data held by us about our customers will be one of the transferred
            assets;
        </p>
    </li>
    <li>
        <p>
            to enforce or apply our Website Terms and Conditions of Use and other agreements; or to
            protect the rights, property, or safety of the Company, our customers, or others. This
            includes exchanging information with other companies and organisations for the purposes
            of fraud protection and credit risk reduction.
        </p>
    </li>
    <li>
        Where permitted by data protection and privacy law, we may disclose information about you,
        including electronic identifiers (such as IP addresses) and/or access to your account:
        <div className="space-y-3" style={{
            paddingLeft: 8
          }}>
            <p>&#x2022; If required or permitted to do so by law;</p>
            <p>
                &#x2022; If required to do so by any court, the Financial Conduct Authority, the
                Competition and Markets Authority, the Information Commissioners Office or any other
                applicable regulatory, compliance, Government, or law enforcement agency;
            </p>
            <p>
                &#x2022; If necessary, in connection with legal proceedings or potential legal
                proceedings. We may also share your details with members of our affiliated companies
                who may use your information for the purposes detailed in this Policy.
            </p>
        </div>
    </li>
      </ul>
      <h3 className="text-lg font-bold">Use of your information outside the UK</h3>
      <p>
    Some companies within our affiliated companies may be located outside of the UK, therefore it is
    sometimes necessary for the Company to transfer information held about you to lenders based
    outside of the European Economic Area. We implement safeguards within our group of affiliated
    companies, so where this occurs your data rights will remain unaltered.
      </p>
      <p>By submitting your Application Form you consent to this transfer.</p>
      <h3 className="text-lg font-bold">What are your rights?</h3>
      <p>
    You have the right of access to your personal information on request. Should you wish to
    exercise this right please contact the Data Protection Officer at the correspondence address
    shown below. We have 1 month to reply to your request, however will always endeavour to provide
    you with the information in a much shorter timescale.
      </p>
      <p>
    You also have the right to ask for your data to be deleted from our database, or corrected where
    there are errors. Simply contact the Data Protection Officer at the correspondence address shown
    below.
      </p>
      <p>
    You also have the right to withdraw your consent to us marketing to you at any time, where
    relevant. This website allows you to withdraw your consent by using the ‘Opt-Out’ page.
      </p>
      <p>
    Alternatively, please contact us using any of the correspondence methods listed below. If you
    opt-out of our use of your data for marketing purposes, we will honour such choice once we have
    had a reasonable opportunity to process your request. We reserve the right to take reasonable
    steps to authenticate your identity with respect to any such request or other enquiry.
      </p>
      <p>
    If you were introduced to us by a third party, we will give them your contact details and
    sufficient information about you for their accounting and administration purposes. We may also
    give out information about you if we have a duty to do so or if the law allows us to do so.
    Otherwise we will keep information about you confidential.
      </p>
      <p>Calls between us may be recorded and/or monitored.</p>
      <h3 className="text-lg font-bold">How we store your personal data</h3>
      <p>
    All information you provide to us is, as far as reasonably practicable, stored on our secure
    servers. Unfortunately, the transmission of information via the internet is not completely
    secure.
      </p>
      <p>
    Although we will do our best to protect your personal data, we cannot guarantee the security of
    your data transmitted to our Sites; any transmission is at your own risk. Once we have received
    your personal data, we will use strict procedures and security features to try to prevent
    unauthorised access.
      </p>
      <p>
    We will retain your information securely for a reasonable period or for as long as the law
    requires.
      </p>
      <h3 className="text-lg font-bold">Cookie and IP addresses</h3>
      <p>
    This website uses cookies. View our Cookie Policy for a full list of the cookies that we use and
    third party cookies.
      </p>
      <h3 className="text-lg font-bold">Applicants aged under 18</h3>
      <p>No one under the age of 18 years old is permitted to use our website or service.</p>
      <h3 className="text-lg font-bold">Complaints</h3>
      <p>
    Should you be unhappy with any aspect of our service or the way your personal information has
    been stored, used or collected our staff will be happy to resolve your concerns. We do recommend
    that you bring any issues to our attention as soon as possible, as the sooner we know about the
    issue the sooner we can help resolve it. Please see our Complaints Policy for further
    information.
      </p>
      <p>
    We will endeavour to satisfy your concerns, however if you remain unsatisfied with any aspect
    relating to your personal information, you have the right to complain to the Information
    Commissioners Office.
      </p>
      <p>
    The ICO may be contacted at: Information Commissioner’s Office Wycliffe House Water Lane
    Wilmslow Cheshire SK9 5AF
      </p>
      <p>
    Telephone: <a href="tel:0303 123 1113">0303 123 1113</a> or 
    <a href="tel:01625 545 745">01625 545 745</a>
      </p>
      <p>
    Alternatively, you may have the right to refer your complaint to the Financial Ombudsman Service
    (please see our Complaints Policy for further details):
      </p>
      <p>
    Financial Ombudsman Service <br />
    Exchange Tower <br />
    London <br />
    E14 9SR <br />
      </p>
      <p>
    Email: 
    <a href="mailto:complaint.info@financial-ombudsman.org.uk" className="underline">
        complaint.info@financial-ombudsman.org.uk
    </a>
    <br />
    Telephone: <a href="tel:0300 123 9123">0300 123 9123</a> or <a href="tel:0800 023 567">0800 023 567</a>
      </p>
      <h3 className="text-lg font-bold">Our contact details</h3>
      <p>
    46 Alexandra Street <br />
    Southend On Sea <br />
    Essex <br />
    SS1 1BJ <br />
      </p>
      <a href="mailto:support@loan.co.uk" className="underline">
    support@loan.co.uk
      </a>
      <br />
      <br />
      <a href="tel:0800 234 5678">0800 234 5678</a>
      <h3 className="text-lg font-bold">Changes to this policy</h3>
  <p>The Company may choose, from time to time, to amend the content of this Policy and should this happen, we will update the Policy and the revised version will be posted on this website. Please ensure that you visit this Policy on a regular basis so that you have read the latest version and continue to understand what we do with your information.</p>
  
  <p>Version 1.1 – 07 March 2023</p>
  
    </div>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;